import React from 'react';

import { Link, Text } from '@betterment/samba-react';

import type { SupportContact } from './types';

export const ContactDetails: React.FC<{ contact: SupportContact }> = ({ contact }) => (
  <>
    <Text as="p">
      <Link href={`mailto:${contact.email}`}>{contact.email}</Link>
    </Text>
    <Text as="p">{contact.phone}</Text>
    <Text as="p">{contact.weekdayHours}</Text>
  </>
);
